<template>
  <blog-tags />
</template>

<script>
/**
 * Vue: Main blog (main-blog)
 * -----------------------------------------------------------------------------
 * Blog page section.
 * - Initialises blog tags functionality.
 *
 */
import BlogTags from '~async/main-blog/blog-tags';

export default {
  name: 'MainBlog',

  components: {
    BlogTags,
  },
};
</script>

<style lang="scss">
@import '@/components/pagination';
@import './article-card';
// Blog tags' styles imported in blog tags components
@import './main-blog';
</style>
